import {
  all,
  call,
  takeLatest,
  put
  // select
} from 'redux-saga/effects'
import { showAlertMessage } from '../alert/actions'
import {
  rejectPromiseAction,
  resolvePromiseAction
} from 'redux-saga-promise-actions'
import * as actions from './actions'
import * as services from './services'
import { jsonToFormdata } from '../../utils/mappers'
import { createPickupQueueRSPA } from '../pickup_queue/actions'

export function * getPickupAuthorizations ({ payload }) {
  try {
    const currentPage = payload.page || 1
    const response = yield call(services.getPickupAuthorizations, payload)
    yield put(
      actions.getPickupAuthorizationsSuccessful({
        response,
        current_page: currentPage
      })
    )
  } catch (error) {
    yield put(actions.getPickupAuthorizationsFailure(error))
  }
}

export function * getAuthorizationById ({ payload }) {
  try {
    const response = yield call(services.getPickupAuthorizationById, payload)
    yield put(actions.getAuthorizationSuccessful(response.data))
  } catch (err) {
    yield put(actions.getAuthorizationFailure(err))
  }
}

export function * deleteAuthorization ({ payload }) {
  try {
    yield call(services.deletePickupAuthorization, payload)
    yield put(actions.deleteAuthorizationSuccessful(payload))
    yield put(
      showAlertMessage({
        message: 'Deletado com sucesso.',
        severity: 'success'
      })
    )
  } catch (error) {
    yield put(actions.deleteAuthorizationFailure(error))
    yield put(
      showAlertMessage({
        message: 'Falha ao deletar.',
        severity: 'error'
      })
    )
  }
}

export function * approveTemporaryAuthorization (action) {
  try {
    const { payload } = action
    const response = yield call(services.approveTemporaryAuth, payload)
    resolvePromiseAction(action, response)
  } catch (err) {
    rejectPromiseAction(action, err)
    console.error(err)
  }
}

export function * editPickupAuthorizationRequest (action) {
  try {
    const { payload } = action
    const fd = new FormData()
    fd.append('data[type]', 'pickup_authorizations')
    fd.append('data[id]', payload.id)
    const id = payload.id
    delete payload.id

    yield jsonToFormdata(fd, payload.data)
    const response = yield call(services.editPickupAuthorizationFd, {
      id,
      fd
    })
    resolvePromiseAction(action, response)
  } catch (error) {
    rejectPromiseAction(action, error)
    console.error(error)
  }
}

export function * createPickupAuthorizationRequest (action) {
  try {
    const { payload } = action
    const fd = new FormData()
    fd.append('data[type]', 'pickup_authorizations')
    yield jsonToFormdata(fd, payload)
    const response = yield call(services.createPickupAuthorizationFd, fd)
    if (payload.pickup_type === 'temporary') {
      yield put(
        createPickupQueueRSPA.request({
          school_id: payload.school_id,
          pickup_authorization_id: response.data.data.id,
          pickup_queue_children_attributes: payload.pickup_authorization_children_attributes.map(
            ({ child_id }) => ({ child_id })
          ),
          status: 'pending',
          approved_by_id: payload.authorized_by_id
        })
      )
    }
    resolvePromiseAction(action, response)
  } catch (error) {
    rejectPromiseAction(action, error)
    console.error(error)
  }
}

export function * watchFetchAuthorizations () {
  yield takeLatest(
    actions.createPickupAuthorizationRSPA.request,
    createPickupAuthorizationRequest
  )
  yield takeLatest(
    actions.editPickupAuthorizationRSPA.request,
    editPickupAuthorizationRequest
  )
  yield takeLatest(actions.getPickupAuthorizations, getPickupAuthorizations)
  yield takeLatest(actions.deleteAuthorization, deleteAuthorization)
  yield takeLatest(actions.getAuthorization, getAuthorizationById)
  yield takeLatest(
    actions.approveTemporaryAuthorizationRSPA.request,
    approveTemporaryAuthorization
  )
}

export default function * pickupAuthorizationsSagas () {
  yield all([watchFetchAuthorizations()])
}
